const InitCart = () => {
  document.body.addEventListener('click', (event) => {
    const target = event.target;

    if (!target.classList.contains('qty-btn')) return;

    // 최신 quantity input 찾기
    const input = target.closest('.quantity').querySelector('.qty');
    let currentValue = parseInt(input.value, 10);

    if (target.classList.contains('qty-minus')) {
      if (currentValue > 1) input.value = currentValue - 1;
    } else if (target.classList.contains('qty-plus')) {
      input.value = currentValue + 1;
    }

    // WooCommerce가 qty 변경을 감지하도록 change 이벤트 발생
    input.dispatchEvent(new Event('change', { bubbles: true }));

    // ★★★ 매번 최신 DOM에서 다시 찾기 (중요)
    const cartForm = document.querySelector('form.woocommerce-cart-form');
    const updateButton = cartForm?.querySelector('button[name="update_cart"]');

    // 버튼 비활성화 되어 있으면 활성화
    if (updateButton) updateButton.disabled = false;

    // 약간의 딜레이 후 폼 submit
    setTimeout(() => {
      const newCartForm = document.querySelector('form.woocommerce-cart-form');
      const newUpdateButton = newCartForm?.querySelector(
        'button[name="update_cart"]'
      );

      if (newUpdateButton) {
        newUpdateButton.disabled = false;
        newUpdateButton.click();
      } else if (newCartForm) {
        newCartForm.submit();
      }
    }, 300);

    event.preventDefault();
  });
};
export default InitCart;
